<div mat-dialog-title>
  <span>{{'translationPreview' | translate}}</span>

  <button mat-icon-button style="color:var(--warmOrange); float:right; " class="m-2 me-0" (click)="closeDialog();">
    <span class="material-symbols-outlined">
      close
    </span>
  </button>
</div>

<mat-dialog-content>

  <section>

    <div class="container p-4 m-4 mt-0">

      <div class="text-center d-flex align-items-center">
        <div class="ms-5 me-3">{{'pass.selectLanguage' | translate}}</div>

        <button
          mat-button
          [matMenuTriggerFor]="languageMenu"
          class="language-button"
          >
          <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
          <span class="text-uppercase ml-2">{{languageSelected}}</span>

        </button>

        <mat-menu #languageMenu="matMenu">
          @for (lang of contextLanguages; track lang) {
            <button
              mat-menu-item
              (click)="changePassLanguage(lang)"
              [disabled]="lang === languageSelected"
              >
              <span [ngStyle]="{'color': lang === languageSelected ? 'var(--warmOrange)' : 'inherit'}">
                {{languagesList[lang]}}
              </span>
            </button>
          }
        </mat-menu>
      </div>

      <div class=" mt-3">
        <div class="">
          <div class="mobile-wrapper " [class.full-view]="false">
            <section class="mobile pt-1">
              <h2 class="text-center"></h2>
              <div class="mobile-frame-container"></div>
            </section>
          </div>
        </div>

      </div>
    </div>
  </section>
</mat-dialog-content>